import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { icon, text } from "@fortawesome/fontawesome-svg-core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { SortType } from "@swimlane/ngx-datatable";
import * as moment from "moment";
import { config, title } from "process";
import { Alert } from "selenium-webdriver";
import { Alerta } from "src/app/models/Alertas/Alerta";
import { AlertaFilter } from "src/app/models/Alertas/AlertaFilter";
import { AlertaUsuariosRequest } from "src/app/models/Alertas/alertaUsuarios";
import { getAlertaDescripcion } from "src/app/models/Alertas/AlertaDescripcion";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { Usuario } from "src/app/models/Usuario/Usuario";
import { UsuarioFilter } from "src/app/models/Usuario/UsuarioFilter";
import { AlertaService } from "src/app/services/alerta.service";
import { EmisorService } from "src/app/services/emisor.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { Permission } from "src/app/shared/models/Permission";
import Swal from "sweetalert2";
import { ConfigMantenedorUsuario } from "../mantenedor-usuarios/config-mantenedor-usuarios";
import { ConfigMantenedorAlerta } from "./config-mantenedor-alertas";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
	selector: "app-mantenedor-alertas",
	templateUrl: "./mantenedor-alertas.component.html",
	styleUrls: ["./mantenedor-alertas.component.scss"],
})
export class MantenedorAlertasComponent implements OnInit {
	SortType = SortType;
	getAlertaDescripcion = getAlertaDescripcion;
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	public sessionEmisorId: string = ""; //obtener emisor predefinido del usuario
	public sessionEmisor: Emisor;
	public filter: AlertaFilter = new AlertaFilter();
	public rowsMantenedor: Alerta[] = [];
	public rowsMantenedorUser: Usuario[] = [];
	public alertToEdit: Alerta = new Alerta();
	public page: Page = new Page();
	public pageUser: Page = new Page();
	public userFilter = new UsuarioFilter();
	public isSuperAdm: boolean = false;
	public alertaForm: FormGroup;
	public emisoresSource: Emisor[];
	public componentStarted: boolean = false;
	defaultFilterCriteria = { criterio: "Certificado", busqueda: "" };
	configLocal = ConfigMantenedorAlerta;
	configLocalUser = ConfigMantenedorUsuario;
	empresasSource: Emisor[];
	sourceForSelectInputs: Array<any> = [];
	columnsToRender: Array<any>;
	public today: number = Date.now();
	public loading: boolean = false;
	public admUsersModal: NgbModalRef;
	public usersModal: NgbModalRef;
	public editMode: boolean = false;
	public selectedAlert: Alerta = new Alerta();
	public editAlertModal: NgbModalRef;
	public files: File[] = [];
	public superAdm = false;
	public createPlantillaModalRef: NgbModalRef;
	@ViewChild("tableMobile") tableRef: any;
	constructor(public alertaService: AlertaService, private tokenService: TokenStorageService, private localStorage: LocalStorageService, public permissions: PermissionService, private utilities: UtilitiesService, private emisorService: EmisorService, private ref: ChangeDetectorRef, private formBuilder: FormBuilder, private modalService: NgbModal,private sessionUserService: SessionUserService) {
		this.superAdm = this.tokenService.getUser().superAdmin;
		this.sessionEmisorId = this.tokenService.getCompany();
		this.emisoresSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.sessionEmisor = this.emisoresSource.find((emisor) => emisor.emisorId == this.sessionEmisorId);
		if (this.superAdm) {
			this.getEmisoresFullList();
		}
		this.filter.activo = true;
		this.filter.emisorId = this.sessionEmisorId;
		this.filter.usuarioId = this.tokenService.getUser().id;
		this.userFilter.usuarioId = this.tokenService.getUser().id;
		this.isSuperAdm = this.tokenService.getUser().superAdmin;
	}
	getEmisoresFullList() {
		this.emisorService.getData().subscribe(
			(result) => {
				let emisores = result.data;
				this.emisoresSource = emisores;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en emisores",
					text: "No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.setPage({ offset: 0 });
	}

	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}
	setUserPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPageUser({ offset: 0 });
	}
	toggleExpandRow(row) {
		this.tableRef.rowDetail.toggleExpandRow(row);
	}
	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		this.alertaService
			.getDataByPage(this.filter, localPage)
			.subscribe(
				(result) => {
					this.loading = false;
					let rows = result.data as Alerta[];
					this.rowsMantenedor = [...rows];
					var today = moment();
					this.rowsMantenedor.forEach((row) => {});
					this.setPageFromResponse(this.page, result);
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "error",
						title: "Error en Lista de Certificados",
						text: "No fue posible obtener la lista de certificados disponibles, recargue la pagina." + this.utilities.setErrorMessageFromArray(error.error),
					});
				}
			)
			.add(() => (this.componentStarted = true));
	}
	setPageFromResponse(currentPage: Page, data: PagedResponse<Alerta>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(
			url,
			title,
			`
scrollbars=yes,
width=${w / systemZoom}, 
height=${h / systemZoom}, 
top=${top}, 
left=${left}
`
		);
		if (window.focus) {
			newWindow.focus();
		}
	}
	searchElementsByFilter(event) {
		//this.filter[event.criterio] = event.busqueda;
		this.filter.nombre = event.criterio == "nombre" ? (event.busqueda ? event.busqueda : "") : "";
		this.filter.activo = event.registroActivo ? false : true;
		this.filter.emisorId = event.emisorId == null ? this.sessionEmisorId : event.emisorId;
		this.setPage({ offset: 0 });
	}

	openAlertUserModal(modalRef, row: Alerta) {
		this.alertToEdit = new Alerta();
		this.alertToEdit = row;
		this.admUsersModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	closeAlertUsersModal() {
		this.setPage({ offset: 0 });
		this.admUsersModal.close();
	}

	updateAlertUsers(modalRef) {
		this.loading = true;
		var request = new AlertaUsuariosRequest();
		request.emisorId = this.filter.emisorId;
		request.usuarios = [];
		request.alertaId = this.alertToEdit.alertaId;
		this.alertToEdit.usuarios.forEach((x) => request.usuarios.push(x.usuarioId));
		this.alertaService.updateAlertUsers(request).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Usuarios Asignados Actualizados",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + "Se actualizaron los usuarios asignados de la alerta " + this.alertToEdit.nombre + "</p></div>",
				});
				this.admUsersModal.close();
				this.setPage({ offset: 0 });
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Usuarios asignados no actualizados",
					text: "Error al actualizar los usuarios de la alerta " + this.alertToEdit.nombre + ". Intenta más tarde." + this.utilities.setErrorMessageFromArray(err.error),
				});
			}
		);
	}

	deleteAlertUsers(user: Usuario) {
		var newList: Usuario[] = [];
		this.alertToEdit.usuarios.forEach((element) => {
			if (element != user) {
				newList.push(element);
			}
		});
		this.alertToEdit.usuarios = newList;
	}
	setPageUser(pageInfo) {
		this.loading = true;
		this.pageUser.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.pageUser));
		localPage.pageNumber += 1;
		this.alertaService
			.getUsuarioDataByPage(this.userFilter, localPage)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as Usuario[];
					this.ref.detectChanges();
					// if(!this.fullListPermission){
					//   this.rowsMantenedorUser = elements.filter((suc) => {
					//     return this.emisoresDeUsuario.some((em) => {
					//       return em.emisorId == suc.emisorId;
					//     });
					//   });
					// }else if(this.fullListPermission){
					//   this.rowsMantenedorUser = [...elements];
					// }
					this.rowsMantenedorUser = [...elements];
					this.setPagefromUsuarioResponse(this.pageUser, pagedData);
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					Swal.fire({
						icon: "error",
						title: "Error en la solicitud",
						text: this.utilities.setErrorMessageFromArray(error.error),
					});
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}
	setPagefromUsuarioResponse(currentPage: Page, data: PagedResponse<Usuario>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	searchUserElements(nombre: string) {
		this.loading = true;
		this.alertaService.getUsuarioDataByPage(this.userFilter, this.pageUser).subscribe(
			(result) => {
				this.loading = false;
				let elements = result.data as Usuario[];
				elements.forEach((row) => {});
				this.rowsMantenedorUser = [...elements];
			},
			(error) => {},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	changeSearchedRowsByUser(data) {
		if (data != null) {
			this.rowsMantenedorUser = data;
		}
	}

	filterConcordanceByUser(configCriterias, UserFilter: UsuarioFilter, eventFilter): UsuarioFilter {
		configCriterias.forEach((criterio) => {
			if (criterio != eventFilter.criterio) {
				UserFilter[criterio] = "";
			}
		});
		return UserFilter;
	}
	searchElementsByUserFilter(event) {
		this.userFilter = this.filterConcordanceByUser(this.configLocal.barraBusqueda.criteriosKeys, this.userFilter, event);
		this.userFilter.rut = event.criterio == "rut" ? (event.busqueda ? event.busqueda : "") : "";
		this.userFilter.nombre = event.criterio == "nombre" ? (event.busqueda ? event.busqueda : "") : "";
		this.userFilter.comuna = event.criterio == "comuna" ? (event.busqueda ? event.busqueda : "") : "";
		this.userFilter.activo = 1;
		this.userFilter.emisorId = this.filter.emisorId != undefined ? this.filter.emisorId : this.sessionEmisorId;
		this.setPageUser({ offset: 0 });
	}

	findUserModal(modalRef) {
		this.loading = true;
		this.userFilter.nombre = "";
		this.userFilter.emisorId = this.filter.emisorId != undefined ? this.filter.emisorId : this.sessionEmisorId;
		this.userFilter.activo = 1;
		this.loading = false;
		this.ref.detectChanges();
		this.usersModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});

		this.setPageUser({ offset: 0 });
	}

	addAlertUser(user: Usuario) {
		this.loading = true;
		var exist = false;
		this.loading = false;
		this.ref.detectChanges();
		if (this.alertToEdit.usuarios == null) this.alertToEdit.usuarios = [];
		if (this.alertToEdit.usuarios != null) {
			this.alertToEdit.usuarios.forEach((element) => {
				if (element.usuarioId == user.usuarioId) {
					exist = true;
					Swal.fire({
						icon: "info",
						title: "Usuarios no asignado",
						text: "El usuario " + user.nombre + " ya esta asignado a la alerta",
					});
				}
			});
		}

		if (!exist) {
			this.alertToEdit.usuarios.push(user);
			Swal.fire({
				icon: "success",
				title: "Usuario Asignado",
				showCloseButton: true,
				html: "<div style='text-align:center;'><p>" + "El usuario " + user.nombre + " fue asignado a la alerta correctamente" + "</p></div>",
			});
			this.usersModal.close();
		}
	}
	openEditAlertModal(modalRef, row: Alerta) {
		this.selectedAlert = row;
		this.editMode = true;
		this.editAlertModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}
	closeEditAlertModal() {
		this.editAlertModal.close();
		this.editMode = false;
		this.selectedAlert = undefined;
	}
	editAlertRequest(request: Alerta) {
		this.loading = true;
		this.alertaService.updateAlert(request).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Alerta modificada",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + "Se han actualizado correctamente los datos de la alerta" + "</p></div>",
				});

				this.closeEditAlertModal();
				this.setPage({ offset: 0 });
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en edición",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + "Ha ocurrido un error al intentar guardar los cambios de la alerta" + this.utilities.setErrorMessageFromArray(error.error) + "</p></div>",
				});
			}
		);
	}
}
